import {
  AmbientLight,
  Color,
  PerspectiveCamera,
  PointLight,
  Scene,
  WebGLRenderer,
} from 'three';

export function createSceneContext(container) {
  const scene = new Scene();
  scene.background = new Color(0x02040a);

  const camera = new PerspectiveCamera(60, window.innerWidth / window.innerHeight, 0.1, 500);
  camera.position.set(0, 8, 28);

  const renderer = new WebGLRenderer({ antialias: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  renderer.setSize(window.innerWidth, window.innerHeight);
  container.appendChild(renderer.domElement);

  const ambient = new AmbientLight(0x4a5266, 0.34);
  scene.add(ambient);

  const key = new PointLight(0xdde8ff, 0.35, 220);
  key.position.set(12, 16, 20);
  scene.add(key);

  function resize() {
    const w = window.innerWidth;
    const h = window.innerHeight;
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
    renderer.setSize(w, h);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  }

  window.addEventListener('resize', resize);

  return { scene, camera, renderer, resize };
}
